import script from "./zjcrk.vue?vue&type=script&setup=true&lang=js"
export * from "./zjcrk.vue?vue&type=script&setup=true&lang=js"

import "./zjcrk.vue?vue&type=style&index=0&id=32b0fd34&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b0fd34"]])

export default __exports__